var map = {
	"./bs_t-2_reflect-stitch_blk.png": 7411,
	"./bs_t-2_reflect-stitch_blu.png": 370509,
	"./bs_t-2_reflect-stitch_cml.png": 795298,
	"./bs_t-2_reflect-stitch_crk.png": 575864,
	"./bs_t-2_reflect-stitch_grn.png": 262521,
	"./bs_t-2_reflect-stitch_lgd.png": 541267,
	"./bs_t-2_reflect-stitch_lsl.png": 489591,
	"./bs_t-2_reflect-stitch_nvy.png": 200479,
	"./bs_t-2_reflect-stitch_orn.png": 880993,
	"./bs_t-2_reflect-stitch_pnk.png": 124651,
	"./bs_t-2_reflect-stitch_ppl.png": 971674,
	"./bs_t-2_reflect-stitch_red.png": 863319,
	"./bs_t-2_reflect-stitch_sax.png": 92738,
	"./bs_t-2_reflect-stitch_wht.png": 103613,
	"./bs_t-2_reflect-stitch_ylw.png": 826996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226685;